/**
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@keystone/common';
import APIClient from '../../common/APIClient';

export const TaskContext = React.createContext();
export const TaskConsumer = TaskContext.Consumer;

class TaskProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rules: [],
      results: null,
      history: [],
      selectedRows: [],
      isConfirmDeleteModalOpen: false,
    };
  }

  scanTask = async (data) => {
    const { user, setNotification, handleError } = this.context;
    try {
      const result = await APIClient.scanTask(data, user);
      if (result.response.result === 0) {
        this.setState({ results: result.response });
        setNotification(
          'Task uploaded successfully. Visit the "Upload History" page to check progress and download DevKit project.',
          'success'
        );
      } else {
        setNotification('An error occured', 'critical');
      }
    } catch (err) {
      handleError(err);
    }
  };

  downloadTaskFile = async (fileDir, fileName, updateFunc) => {
    const { user, handleError } = this.context;
    try {
      await APIClient.downloadTaskFileAxios(fileDir, fileName, user, updateFunc);
    } catch (err) {
      handleError(err);
    }
  };

  home = async () => {
    const { user, handleError } = this.context;
    try {
      await APIClient.home(user.idToken);
    } catch (err) {
      handleError(err);
    }
  };

  getIdToken = () => {
    const { user } = this.context;
    return user.idToken;
  };

  toggleConfirmDeleteUserModal = () => {
    const { isConfirmDeleteModalOpen } = this.state;
    this.setState({
      isConfirmDeleteModalOpen: !isConfirmDeleteModalOpen,
    });
  };

  setSelectedRows = (selectedRows) => {
    this.setState({ selectedRows });
  };

  resetResults = (results) => {
    this.setState({ results });
  };

  getUser = () => {
    const { user } = this.context;
    return user;
  };

  clearNotification = () => {
    const { setNotification } = this.context;
    setNotification(null, null);
  };

  render() {
    const { children } = this.props;
    const { results, selectedRows, rules, history, isConfirmDeleteModalOpen } = this.state;
    return (
      <TaskContext.Provider
        value={{
          // state vars
          results,
          selectedRows,
          rules,
          history,
          isConfirmDeleteModalOpen,

          // api methods
          scanTask: this.scanTask,
          downloadTaskFile: this.downloadTaskFile,
          getIdToken: this.getIdToken,
          fetchHistory: this.fetchHistory,
          toggleConfirmDeleteUserModal: this.toggleConfirmDeleteUserModal,
          setSelectedRows: this.setSelectedRows,
          resetResults: this.resetResults,
          home: this.home,
          getUser: this.getUser,
          clearNotification: this.clearNotification,
        }}
      >
        {children}
      </TaskContext.Provider>
    );
  }
}

TaskProvider.contextType = AppContext;

TaskProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TaskProvider;
